import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import type { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Summary } from './components/Summary.tsx';
import { Legend } from './Legend.tsx';

export type StructureAndLogicProps = {
  hideCriteria: boolean;
  showExcludeSection: boolean;
  isEdit: boolean;
  isCreate: boolean;
  isCreateFromTemplate?: boolean;
};

export const StructureAndLogic = ({
  hideCriteria,
  showExcludeSection,
  isEdit,
  isCreate,
  isCreateFromTemplate,
}: StructureAndLogicProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ padding: (theme: Theme) => theme.spacing(0, 3, 0, 3) }}>
      <Typography variant="h3">{t('Structure & Logic')}</Typography>
      <Divider sx={{ mt: 3, mb: 2 }} />
      <Legend />
      <Divider sx={{ mt: 2, mb: 3 }} />
      {hideCriteria ? (
        <>
          <Typography
            data-test="default-reach-title"
            variant="body1"
            sx={{
              mb: 3,
            }}
          >
            {t('No data available.')}
          </Typography>

          <Alert severity="info">
            <Typography variant="body1"> {t('Select Match Type and Provider first.')} </Typography>
          </Alert>
        </>
      ) : (
        <>
          <Summary
            path="normalized_definition.includes"
            sectionName={t('Includes')}
            listType="includes"
            isEdit={isEdit}
            isCreate={isCreate}
            isCreateFromTemplate={isCreateFromTemplate}
          />

          {showExcludeSection && (
            <Summary
              path="normalized_definition.excludes"
              sectionName={t('Excludes')}
              listType="excludes"
              isEdit={isEdit}
              isCreate={isCreate}
              isCreateFromTemplate={isCreateFromTemplate}
            />
          )}
        </>
      )}
    </Box>
  );
};
